function apiBase() {
  const raw =
    process.env.REACT_APP_NODE_API_URL ||
    process.env.REACT_APP_API_URL ||
    '';
  return String(raw)
    .trim()
    .replace(/^['"]|['"]$/g, '')
    .replace(/\/$/, '');
}

export function toRelativeMediaPath(path) {
  if (path == null || typeof path !== 'string') {
    return path;
  }
  const trimmed = path.trim();
  if (!trimmed || /^(data:|blob:)/i.test(trimmed)) {
    return trimmed;
  }
  if (/^https?:\/\//i.test(trimmed)) {
    try {
      const { pathname, search } = new URL(trimmed);
      if (pathname.startsWith('/uploads/') || pathname.startsWith('/image/')) {
        return `${pathname}${search}`;
      }
    } catch {
      // ignore
    }
    return trimmed;
  }
  return trimmed;
}

export function resolveMediaUrl(value) {
  if (value == null || value === '') {
    return value;
  }
  if (typeof value !== 'string') {
    return value;
  }

  const v = value.trim();
  if (!v || v.startsWith('data:') || v.startsWith('blob:')) {
    return v;
  }
  if (/^https?:\/\//i.test(v) || v.startsWith('//')) {
    try {
      const { pathname, search } = new URL(v.startsWith('//') ? `https:${v}` : v);
      if (pathname.startsWith('/uploads/') || pathname.startsWith('/image/')) {
        const base = apiBase();
        return base ? `${base}${pathname}${search}` : `${pathname}${search}`;
      }
    } catch {
      // ignore
    }
    return v;
  }
  if (v.startsWith('/static/')) {
    return v;
  }

  const base = apiBase();
  if (!base) {
    return v;
  }

  if (v.startsWith('/uploads/') || v.startsWith('/image/')) {
    return `${base}${v}`;
  }
  if (v.startsWith('/')) {
    return `${base}${v}`;
  }
  if (!v.includes('/') && /\.(png|jpe?g|gif|webp|svg|ico)$/i.test(v)) {
    return `${base}/image/${v}`;
  }
  return v;
}

export function resolveMediaCssUrl(path) {
  const resolved = resolveMediaUrl(path);
  if (!resolved) {
    return '';
  }
  return `url("${resolved}")`;
}

export default resolveMediaUrl;
